import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import update from 'immutability-helper';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//components:
import NeuriteGrid from '../../components/neurite_grid';

//actions:
import { navigate, openDialog, hideDialog, setSaveState } from '../../actions';
import { getTiposGasto, addTipoGasto, removeTipoGasto, modifyTipoGasto, updateTiposGastoDB } from '../../actions/tipos_gasto_actions';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import * as config from '../../constants/configuration';


const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    toolbar: {
        display: 'block',
        minHeight: '112px'
    },
    marginBottom: {
        marginBottom: 20,
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        marginBottom: 60,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
        marginLeft: 8,
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});

class MaeAuxiliaresTipoGasto extends Component {

    componentDidMount() {

        if (!this.props.user && config.AUTH) {
            this.props.navigate(""); //go to home page
            return;
        }

        this.props.getTiposGasto();

    };

    messageDialog = (msg) => {

        this.props.openDialog('SimpleMessage', {
            message: msg
        }, uuidv4(), false, 'sm');

    };

    checkTipoGasto = (tipoGasto) => {
        if (this.props.tipoGasto.find(c => (c.descr === tipoGasto.descr) && (c.id !== tipoGasto.id))) {
            this.messageDialog(`Ya existe un tipo de gasto ${tipoGasto.descr}`);
            return false;
        } else if (!tipoGasto.descr.trim()) {
            this.messageDialog('Por favor, introduzca una descripción');
            return false;
        }

        else return true;
    };

    newTipoGasto = () => {
        this.props.openDialog('EditCvTipoGasto', {
            cvTipoGasto: {},
            okHandler: (tg) => {
                this.props.setSaveState(true);
                this.props.addTipoGasto(tg);
            },
            checkTipoGasto: this.checkTipoGasto,
        }, uuidv4());
    };



    handleDeleteRow = tipoGasto => {
        this.props.setSaveState(true);
        this.props.removeTipoGasto(tipoGasto);
    };

    handleGridRowsUpdated = ({ fromRow, toRow, fromRowData, updated }) => {

        if (fromRow !== toRow) return; //solo modificamos una fila

        // for (let i = fromRow; i <= toRow; i++) {
        //     // if(updated['isContab'] !== undefined){
        //     //      if(updated['isContab']) updated['isContab'] = 1;
        //     //     else updated['isContab'] = 0;
        //     // }
        //     let updatedRow = update(this.props.tipoGasto[i], { $merge: updated });
        //     this.props.setSaveState(true);
        //     this.props.modifyTipoGasto(updatedRow);
        // }

        let updatedRow = update(this.props.tipoGasto[fromRowData.grid_index], { $merge: updated });
        this.props.setSaveState(true);
        this.props.modifyTipoGasto(updatedRow);

    };

    render() {

        const { classes } = this.props;

        return (
            <div className={classes.root}>
                <div className={classes.toolbar} />
                <div className={classes.marginBottom}>

                    <NeuriteGrid
                        id="m_a_t_g"
                        columns={[
                            { key: 'descr', name: 'Descripción', editable: true, dragable: false },
                            { key: 'isContab', name: '¿Is Contab?', editable: true, type: 'bool', dragable: false, width: 85 },
                        ]}
                        rows={this.props.tipoGasto}
                        height={500}
                        buttonEdit={false}
                        buttonDelete={true}
                        buttonNew={true}
                        onNewRowClick={this.newTipoGasto}
                        onRowsUpdated={this.handleGridRowsUpdated}
                        onDeleteClick={this.handleDeleteRow}
                        enableFilter={true}

                    />
                </div>

                <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                    this.props.tipoGasto.forEach(e => {
                        if (typeof e.id !== 'number') e.id = -1;
                    });

                    this.props.updateTiposGastoDB(this.props.tipoGasto)
                }}>Guardar</Button>
            </div>
        );

    };

};

MaeAuxiliaresTipoGasto.propTypes = {
    //state
    user: PropTypes.object.isRequired,
    tipoGasto: PropTypes.array.isRequired,
    //dispatch
    navigate: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    getTiposGasto: PropTypes.func.isRequired,
    addTipoGasto: PropTypes.func.isRequired,
    removeTipoGasto: PropTypes.func.isRequired,
    updateTiposGastoDB: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        tipoGasto: state.tipoGasto.tiposgasto,
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        navigate,
        openDialog,
        hideDialog,
        getTiposGasto,
        addTipoGasto,
        modifyTipoGasto,
        removeTipoGasto,
        updateTiposGastoDB,
        setSaveState
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(MaeAuxiliaresTipoGasto));

